module.exports = __webpack_public_path__ + "img/visa_master_card.dd793ec8.svg";